import Detail from "features/Accountant/CodManagement/Detail/Detail";
import React from "react";

const CodManagementDetail = () => {
  return <Detail />;
};

export default CodManagementDetail;
